export const loadClarity = (projectId) => {
  if (typeof window === 'undefined') return
  if (!projectId) return
  if (window.__clarity_loaded__) return
  if (typeof window.clarity !== 'function') {
    window.clarity = function () {
      (window.clarity.q = window.clarity.q || []).push(arguments)
    }
  }
  const existing = document.querySelector(`script[src="https://www.clarity.ms/tag/${projectId}"]`)
  if (existing) {
    window.__clarity_loaded__ = true
    return
  }
  const s = document.createElement('script')
  s.async = true
  s.src = `https://www.clarity.ms/tag/${projectId}`
  s.crossOrigin = 'anonymous'
  s.onerror = (e) => {
    // eslint-disable-next-line no-console
    console.error('[clarity] load error', e)
  }
  s.onload = () => {
    window.__clarity_loaded__ = true
  }
  document.head.appendChild(s)
}

